import { render, staticRenderFns } from "./Config3.vue?vue&type=template&id=4ea2ed48&scoped=true"
import script from "./Config3.vue?vue&type=script&lang=js"
export * from "./Config3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea2ed48",
  null
  
)

export default component.exports